/**
 * @generated SignedSource<<3adebb861a4734f8a5ae8c4e98b2a746>>
 * @relayHash 0c90169da883bac60f8fe8cfefab06a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type ActiveInlineCommentsQuery$variables = {
  contentStatus?: ReadonlyArray<GraphQLContentStatus | null | undefined> | null | undefined;
  inlineMarkerRefList: ReadonlyArray<string>;
  pageId: string;
};
export type ActiveInlineCommentsQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly permissionType: SitePermissionType | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      };
      readonly body: {
        readonly value: string;
      };
      readonly contentStatus: string;
      readonly createdAt: {
        readonly value: string;
      };
      readonly createdAtNonLocalized: string;
      readonly id: string;
      readonly links: {
        readonly editui: string | null | undefined;
        readonly webui: string | null | undefined;
      };
      readonly location: {
        readonly commentResolveProperties?: {
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null | undefined;
          readonly resolvedTime: AGG$Long | null | undefined;
          readonly resolvedUser: string | null | undefined;
        } | null | undefined;
        readonly inlineMarkerRef?: string | null | undefined;
        readonly inlineResolveProperties?: {
          readonly isDangling: boolean;
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null | undefined;
          readonly resolvedTime: AGG$Long | null | undefined;
          readonly resolvedUser: string | null | undefined;
        } | null | undefined;
        readonly inlineText?: string | null | undefined;
        readonly type: string;
      };
      readonly parentId: string | null | undefined;
      readonly permissions: {
        readonly isEditable: boolean;
        readonly isRemovable: boolean;
        readonly isResolvable: boolean;
      };
      readonly reactionsSummary: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null | undefined>;
      } | null | undefined;
      readonly replies: ReadonlyArray<{
        readonly author: {
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly permissionType: SitePermissionType | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
        };
        readonly body: {
          readonly value: string;
        };
        readonly contentStatus: string;
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly links: {
          readonly editui: string | null | undefined;
          readonly webui: string | null | undefined;
        };
        readonly location: {
          readonly commentResolveProperties?: {
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null | undefined;
            readonly resolvedTime: AGG$Long | null | undefined;
            readonly resolvedUser: string | null | undefined;
          } | null | undefined;
          readonly inlineMarkerRef?: string | null | undefined;
          readonly inlineResolveProperties?: {
            readonly isDangling: boolean;
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null | undefined;
            readonly resolvedTime: AGG$Long | null | undefined;
            readonly resolvedUser: string | null | undefined;
          } | null | undefined;
          readonly inlineText?: string | null | undefined;
          readonly type: string;
        };
        readonly parentId: string | null | undefined;
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly reactionsSummary: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null | undefined>;
        } | null | undefined;
        readonly version: {
          readonly by: {
            readonly displayName: string | null | undefined;
          } | null | undefined;
          readonly number: number | null | undefined;
          readonly when: string | null | undefined;
        };
      } | null | undefined>;
      readonly version: {
        readonly by: {
          readonly displayName: string | null | undefined;
        } | null | undefined;
        readonly number: number | null | undefined;
        readonly when: string | null | undefined;
      };
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ActiveInlineCommentsQuery = {
  response: ActiveInlineCommentsQuery$data;
  variables: ActiveInlineCommentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inlineMarkerRefList"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v3 = {
  "kind": "Variable",
  "name": "pageId",
  "variableName": "pageId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "contentStatus"
  },
  {
    "kind": "Variable",
    "name": "inlineMarkerRefList",
    "variableName": "inlineMarkerRefList"
  },
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v7 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v8 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v9 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v6/*: any*/)
},
v10 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v11 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "editui"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "type"
},
v13 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v14 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v15 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v16 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "kind": "ScalarField",
      "name": "inlineText"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isDangling"
        },
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/)
      ]
    }
  ],
  "type": "InlineComment"
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "commentResolveProperties",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/)
      ]
    }
  ],
  "type": "FooterComment"
},
v19 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v21 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v23 = {
  "kind": "ScalarField",
  "name": "when"
},
v24 = {
  "kind": "ScalarField",
  "name": "number"
},
v25 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        (v22/*: any*/)
      ]
    },
    (v23/*: any*/),
    (v24/*: any*/)
  ]
},
v26 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v29 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/)
  ]
},
v30 = {
  "args": [
    {
      "kind": "Literal",
      "name": "childType",
      "value": "comment"
    },
    {
      "kind": "Literal",
      "name": "contentType",
      "value": "page"
    },
    (v3/*: any*/)
  ],
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "reactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "reacted"
        }
      ]
    }
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v32 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v12/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/)
  ]
},
v33 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        (v22/*: any*/)
      ]
    },
    (v23/*: any*/),
    (v24/*: any*/)
  ]
},
v34 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v22/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ActiveInlineCommentsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v25/*: any*/),
              (v29/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v25/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/)
                ]
              },
              (v30/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActiveInlineCommentsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v32/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v32/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v30/*: any*/)
                ]
              },
              (v30/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0c90169da883bac60f8fe8cfefab06a0",
    "id": "552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4",
    "metadata": {},
    "name": "ActiveInlineCommentsQuery",
    "operationKind": "query",
    "text": "query ActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList,pageId:$pageId,contentStatus:$contentStatus){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
  }
};
})();

(node as any).hash = "93367b15ee96494c20452626f5b23b5d";

export default node;
